<g clip-path="url(#clip0_36_5824)">
    <path
        d="M16.4367 13.3011L14.0184 9.93522H12.9629V13.3011H11.0522V3.95081H15.074C16.0713 3.95081 16.8529 4.22473 17.4188 4.77206C17.9846 5.31992 18.2675 6.06088 18.2675 6.99601C18.2675 7.7438 18.0849 8.3541 17.7195 8.82587C17.3542 9.29816 16.8377 9.61826 16.1695 9.78776L18.7882 13.3005H16.4367V13.3011ZM12.9629 5.76754V8.26542H14.8604C15.3501 8.26542 15.7176 8.15627 15.9627 7.93797C16.2078 7.72019 16.3301 7.41478 16.3301 7.0233C16.3301 6.63183 16.2052 6.32432 15.9559 6.10129C15.706 5.87879 15.3412 5.76754 14.8604 5.76754H12.9629Z"
        fill="#BFBFBF"
    />
    <path
        d="M20.7856 5.17986C21.7163 4.25365 22.8721 3.79028 24.2526 3.79028C25.6331 3.79028 26.7911 4.25365 27.7265 5.17986C28.6618 6.10607 29.1295 7.25478 29.1295 8.62599C29.1295 9.9972 28.6618 11.1459 27.7265 12.0721C26.7916 12.9989 25.6331 13.4617 24.2526 13.4617C22.8721 13.4617 21.7163 12.9989 20.7856 12.0721C19.855 11.1464 19.3894 9.9972 19.3894 8.62599C19.3894 7.25478 19.855 6.10607 20.7856 5.17986ZM26.357 6.46186C25.8006 5.89249 25.0993 5.60702 24.2532 5.60702C23.407 5.60702 22.7052 5.89197 22.1488 6.46186C21.5924 7.03175 21.3142 7.7533 21.3142 8.62599C21.3142 9.49867 21.5924 10.2202 22.1488 10.7901C22.7052 11.36 23.407 11.645 24.2532 11.645C25.0993 11.645 25.8006 11.36 26.357 10.7901C26.9134 10.2202 27.1921 9.4992 27.1921 8.62599C27.1921 7.7533 26.9134 7.03175 26.357 6.46186Z"
        fill="#BFBFBF"
    />
    <path
        d="M50.4044 13.3011L49.616 11.097H45.8351L45.0336 13.3011H43.0158L46.5169 3.95081H48.9352L52.4358 13.3005H50.4044V13.3011ZM46.4902 9.28031H48.9488L47.7195 5.88771L46.4902 9.28031Z"
        fill="#BFBFBF"
    />
    <path
        d="M57.8535 3.95081H59.8707L56.7847 13.3005H54.3802L51.3205 3.95081H53.3382L55.5827 11.043L57.8535 3.95081Z"
        fill="#BFBFBF"
    />
    <path
        d="M67.1962 5.76754H62.8274V7.65092H66.8356V9.46765H62.8274V11.4843H67.1962V13.3011H60.9167V3.95081H67.1962V5.76754Z"
        fill="#BFBFBF"
    />
    <path
        d="M42.4163 3.922L40.1377 11.0362L37.8864 3.922H37.8843H35.8623H35.8608L33.5821 11.0362L32.2053 6.68488H30.2112L32.3764 13.3011H34.7884L36.8691 6.99764L38.9314 13.3011H41.3439L44.4393 3.922H42.4163Z"
        fill="#BFBFBF"
    />
    <path
        d="M40.3575 10.3493L41.7899 11.9482L45.5666 0.538818H43.5011L40.3575 10.3493Z"
        fill="#BFBFBF"
    />
    <path
        d="M2.72555 6.46207C3.2599 5.8927 3.95908 5.60723 4.82307 5.60723C5.39311 5.60723 5.89387 5.73422 6.32639 5.9882C6.75839 6.24167 7.08593 6.59588 7.30849 7.0498H9.35246C9.07636 6.07951 8.53099 5.29342 7.71581 4.69256C6.90064 4.09171 5.94111 3.79102 4.83671 3.79102C3.43837 3.79102 2.28253 4.24966 1.36972 5.16695C0.573445 5.96669 0.124652 6.9501 0.0233459 8.11613H1.96339C2.05262 7.46332 2.3051 6.91074 2.72555 6.46207Z"
        fill="#BFBFBF"
    />
    <path
        d="M4.31499 8.2252V9.82836H7.45497C7.29435 10.4161 6.97363 10.8747 6.49282 11.2038C6.01148 11.5333 5.44616 11.6981 4.79633 11.6981C3.90557 11.6981 3.20377 11.411 2.69199 10.837C2.17968 10.2629 1.92405 9.53921 1.92405 8.66653C1.92405 8.47499 1.93875 8.2929 1.9629 8.11658H0.0223267C0.00762942 8.2866 -0.000244141 8.46082 -0.000244141 8.63924C-0.000244141 10.0283 0.444875 11.1791 1.33564 12.0917C2.22587 13.0048 3.3308 13.4608 4.64883 13.4608C5.41467 13.4608 6.07605 13.3002 6.63297 12.9796C6.76262 12.9051 6.88125 12.8237 6.99253 12.7387L9.41496 8.22468H4.31499V8.2252Z"
        fill="#BFBFBF"
    />
    <path
        d="M4.7077 13.4616C8.48124 13.4931 9.59771 10.4489 9.44234 8.22546H8.99669L8.46706 9.76197"
        fill="#BFBFBF"
    />
</g>
<defs>
    <clipPath id="clip0_36_5824">
        <rect
            width="67.1961"
            height="12.9223"
            fill="white"
            transform="translate(0 0.538818)"
        />
    </clipPath>
</defs>
